import { createAction, props } from '@ngrx/store';

export const commodityTableRequest = createAction(
    '[Commodity Table] Load Request'
);

export const commodityTableSuccess = createAction(
    '[Commodity Table] Load Response',
    props<{ totalCount: number, page: any }>()
);

export const commodityTableFailure = createAction(
    '[Commodity Table] Load Failure'
);

export const commodityTableChangePage = createAction(
    '[Commodity Table] Change Page',
    props<{ pageNumber: number, itemsPerPage: number }>()
);

export const commodityTableChangeQuery = createAction(
    '[Commodity Table] Change Filter',
    props<{ query: any }>()
);

export const commodityTableSort = createAction(
    '[Commodity Table] Change Sort Column',
    props<{ id: string, descending: boolean }>()
);

export const commodityTableSetSelection = createAction(
    '[Commodity Table] Set Selection',
    props<{ selection: string[] }>()
);

export const commodityTableMasterToggle = createAction(
    '[Commodity Table] Master Selection Toggle'
);

export const commodityTableToggle = createAction(
    '[Commodity Table] Toggle Selection',
    props<{ id: string }>()
);

export const commodityTableAddAssist = createAction(
    '[Commodity Table] Add Filter Assist',
    props<{ id: string, parameter: any }>()
);

export const commodityTableRemoveAssist = createAction(
    '[Commodity Table] Remove Filter Assist',
    props<{ id: string }>()
);

export const commodityTableDelete = createAction(
    '[Commodity Table] Delete Selection'
);

export const commodityTableDeleteSuccess = createAction(
    '[Commodity Table] Delete Success'
);

export const commodityTableDeleteFailure = createAction(
    '[Commodity Table] Delete Failure'
);
